var ctFlextimeBalanceModel;
(function ($) {
 	$.fn.capitechFlexiTimeBalance = function(options) {
		var $ctFlextimeBalanceElm = $(this);
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			var modelData = {};
			modelData.flextimeBalance = [];
			modelData.hasFlexitime = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasFlexitime;
			ctFlextimeBalanceModel = ko.viewmodel.fromModel(modelData);
			$('*[data-ko-bind="ctFlextimeBalanceModel"]').each(function(index, obj) {
				ko.applyBindings(ctFlextimeBalanceModel,obj);
			});
			if (getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasFlexitime === true) {
				getFlexiTimeBalance();
				$('#flexitime-tab').trigger('click');
			} else {
				$('#vacation-tab').trigger('click');
			}
		}
		
		function getFlexiTimeBalance() {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					modelData.flextimeBalance = data.content;
					modelData.hasFlexitime = getLocalStorage('myCapitechPermissionsAndRegistrationSetup').hasFlexitime;
					ko.viewmodel.updateFromModel(ctFlextimeBalanceModel, modelData);
					
					$ctFlextimeBalanceElm.find('.table-responsive').scrollLeft(1000);
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			
			loaderIndicator(true);
			_api.getFlexiTimeBalance_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), moment(new Date()).format('YYYY'));
		}
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
	};
}(jQuery));